import { UserMediaContext } from "@/Components/Providers";
import { type UserMediaErrors, useAppSelector, useAppTranslation } from "@/utils";
import { URLS } from "@payping/utilities-shared/consts";
import { Alert, Button, Flex, Typography } from "@payping/web-components";
import { FC, useContext, useEffect } from "react";

interface IntroProps {
  onFinish: () => void;
  onError: (error: UserMediaErrors) => void;
}
const GetOrderUploadVideoAndSignaturePageIntro: FC<IntroProps> = ({ onFinish, onError }) => {
  const { t } = useAppTranslation();
  const profile = useAppSelector((state) => state.bnplConsumer.profile);
  const { initializeCamera, isLoading, mediaStream, error } = useContext(UserMediaContext);
  const handleContinue = async () => {
    await initializeCamera();
  };

  useEffect(() => {
    if (mediaStream) {
      onFinish();
    }
    if (error) {
      onError(error);
    }
  }, [mediaStream, error, onFinish, onError]);

  return (
    <>
      <Flex vertical justify="space-between" className="tw:h-full">
        <Flex vertical gap={"middle"} className="tw:w-full">
          <Typography.Title className="tw:m-0!" level={5}>
            {t("pay.getOrder.steps.uploadVideoAndSignature.title")}
          </Typography.Title>
          <Typography.Text>{t("pay.getOrder.steps.uploadVideoAndSignature.intro.title")}</Typography.Text>
          <Flex className="tw:w-full" justify="center">
            {profile.isMale ? (
              <img className="tw:h-32 tw:w-auto" src={`${URLS.STORAGE_URL}/bnpl-consumer/authentication-male.png`} />
            ) : (
              <img className="tw:h-32 tw:w-auto" src={`${URLS.STORAGE_URL}/bnpl-consumer/authentication-female.png`} />
            )}
          </Flex>
          <ul className="tw:m-0">
            {(profile.isMale
              ? (t("pay.getOrder.steps.uploadVideoAndSignature.intro.rulesForMan", { returnObjects: true }) as string[])
              : (t("pay.getOrder.steps.uploadVideoAndSignature.intro.rulesForWoman", {
                  returnObjects: true,
                }) as string[])
            ).map((item, index) => (
              <li key={index}>
                <Typography.Text>{item}</Typography.Text>
              </li>
            ))}
            {(t("pay.getOrder.steps.uploadVideoAndSignature.intro.rules", { returnObjects: true }) as string[]).map(
              (item, index) => (
                <li key={index}>
                  <Typography.Text>{item}</Typography.Text>
                </li>
              ),
            )}
          </ul>
        </Flex>
        <Flex vertical className="tw:w-full" gap={"middle"}>
          <Alert
            title={t("pay.getOrder.steps.uploadVideoAndSignature.intro.accessInfoAlert.title")}
            description={t("pay.getOrder.steps.uploadVideoAndSignature.intro.accessInfoAlert.content")}
            type="info"
            showIcon
          />
          <Button loading={isLoading} type="primary" block onClick={handleContinue}>
            {t("common.continue")}
          </Button>
        </Flex>
      </Flex>
    </>
  );
};

export default GetOrderUploadVideoAndSignaturePageIntro;
